var _tspan;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 432.04 180.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "72.12 58 57.63 49.69 57.63 66.42 72.12 58",
    style: {
      fill: "#a39acb",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.73 122.56 109.92 102.24 75.22 82.16 40.03 102.48 74.73 122.56",
    style: {
      fill: "#a39acb",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.05 55.15 52.3 46.35 34.82 36.31 32.1 34.7 34.82 33.09 52.17 23.17 36.93 14.38 1.74 34.7 37.05 55.15",
    style: {
      fill: "#a39acb",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.21 155.53 52.05 144.62 33.21 133.71 14.38 144.62 33.21 155.53",
    style: {
      fill: "#a39acb",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.57 21.81 97.28 10.9 78.44 0 59.61 10.9 78.57 21.81",
    style: {
      fill: "#a39acb",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.03 43.13 54.03 26.27 39.41 34.7 54.03 43.13",
    style: {
      fill: "#213c71",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.78 105.46 76.46 125.78 76.46 166.55 111.78 146.23 111.78 105.46",
    style: {
      fill: "#213c71",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.11 78.69 74.11 61.09 56.63 71.13 54.03 72.62 54.03 69.52 54.03 49.57 38.79 58.37 38.79 99.02 74.11 78.69",
    style: {
      fill: "#213c71",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "34.95 158.75 34.95 180.56 53.91 169.53 53.91 147.84 34.95 158.75",
    style: {
      fill: "#213c71",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.3 25.03 80.3 46.72 99.14 35.81 99.14 14.13 80.3 25.03",
    style: {
      fill: "#213c71",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35.19 58.24 0 37.92 0 78.69 35.19 99.02 35.19 58.24",
    style: {
      fill: "#924299",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.63 157.51 72.74 166.43 72.74 125.66 37.55 105.21 37.55 122.81 56.63 133.84 57.63 134.33 57.63 135.45 57.63 157.51",
    style: {
      fill: "#924299",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.35 158.75 31.35 180.56 12.39 169.53 12.39 147.84 31.35 158.75",
    style: {
      fill: "#924299",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.58 25.03 76.58 46.72 57.63 35.81 57.63 14.13 76.58 25.03",
    style: {
      fill: "#924299",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.49,92.08V92H289v.13a9,9,0,0,1,3.72.74,7.17,7.17,0,0,1,2.6,2.11,4.9,4.9,0,0,1,.87,3,4.83,4.83,0,0,1-.87,2.85,7.28,7.28,0,0,1-2.6,2.11,11.79,11.79,0,0,1-3.72.86H246.24L230,69H199.27l10.78,23H186.51l10.78-23H166.43l-26.89,58h30.61l5.45-11.65h45.23L226.29,127H289a44.07,44.07,0,0,0,14.13-2.35,42.65,42.65,0,0,0,5.45-2.23L306.34,127h30.73l5.33-11.65h45.36L393.21,127h30.86L396.93,69H366.2l10.78,23H353.43l10.78-23H333.36L323.69,89.6c-4.46-12.27-17.47-19.33-30-20.57H239.05A28.51,28.51,0,0,0,249,83.52a37.45,37.45,0,0,0,11.4,6.2,48.42,48.42,0,0,0,14.13,2.36Z",
    style: {
      fill: "#213c71",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(98.76 152.92) scale(1.24 1)",
    style: {
      fontSize: "22.87795066833496px",
      fill: "#231f20",
      fontFamily: "Calibri"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    xmlSpace: "preserve"
  }, "     Automation Spirit Alliance"))), /*#__PURE__*/React.createElement("path", {
    d: "M227.4,63.33l-3.47-7.44L213,32.59H182.42l14.25,30.74Zm166.8,0L380,32.59H349.22l14.25,30.74Zm-127.27,0a6.55,6.55,0,0,1-.25-1.62,5.67,5.67,0,0,1,1-3,6,6,0,0,1,2.6-2c1.11-.5,1.11-1,2.48-1h44.73l12-23.18H274A43.25,43.25,0,0,0,259.87,35a39.49,39.49,0,0,0-11.53,6.19,30.8,30.8,0,0,0-7.8,9.3,25.27,25.27,0,0,0-2.85,11.27c0,.62.12,1.12.12,1.62Z",
    style: {
      fill: "#924299",
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsa);
export default __webpack_public_path__ + "static/media/ASA.c6d36df6604156b5d0d0db824da0ef01.svg";
export { ForwardRef as ReactComponent };